import React, {useMemo} from 'react';
import {Box, Container, Divider, Grid, Typography} from "@mui/material";
import {CmCollection, PageGridPlacement as CmPageGridPlacement} from "../../../../packages/graphql-layer/src";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import C036SearchField from "../../content/C036SearchField/C036SearchField";
import CCOContainer from "../../fundamentals/CCOContainer";
import {usePageContext} from "../../../context/PageContext";
import {SkipLinks} from "../../fundamentals/SkipLinks";

export interface Props {
    empty?: boolean
    header: CmPageGridPlacement
    onItemClick?: any
}


const topNaviStyle = {
    height: 52,
    position: "fixed",
    zIndex: 1100,
    display: {
        xs: "none",
        lg: "flex"
    },
    justifyContent: "space-between",
    width: '100%',
    flexGrow: 1,
    alignItems: "center",
    backgroundColor: "#ffffff"
}

const topNaviHoverStyle = {
    "&:hover": {
        color: "primary.main",
        background: "none",
        textDecoration: "underline  2px",
        textDecorationColor: "primary.main",
        textUnderlineOffset: "4px",
    },
}

const searchFieldStyle = {style: {fontSize: 'var(--font-size-menu-item)'}}

const renderLink = (i: any, index: number, onItemClick?: any) => {
    const key = "key" + index;

    return (
        <React.Fragment key={key}>
            {index === 0 ? null : <Divider orientation="vertical" flexItem sx={{marginX: 3}}/>}
            <Grid item onClick={onItemClick}>
                <CCOLinkable key={index} target={i}>
                    <Typography sx={topNaviHoverStyle} variant="navigationItemDense">
                        {i.teaserTitle}
                    </Typography>
                </CCOLinkable>
            </Grid>
        </React.Fragment>
    )
};

const TopNavi = (props: Props) => {

    const items = useMemo(() => {
        const topNavi = props.header?.items?.find((cmCol: CmCollection) => cmCol.viewtype === "asTopNavi") as CmCollection;
        return topNavi?.items ?? [];
    }, [props.header]);

    const {hideTopNavi} = usePageContext()
    if (hideTopNavi) {
        return (
                <SkipLinks
            isWithoutNavi={props.empty}
            isWithoutTopNavi
        />
);
    }

    return (
        <React.Fragment>
            <Container id="topnavi" maxWidth={false} data-object-name="Top Navigation" sx={topNaviStyle}>
                <CCOContainer width="full">
                    <SkipLinks isWithoutNavi={props.empty}/>
                    <Box data-cypress="topNaviSearchField" display="flex" justifyContent="space-between"
                         alignItems="center" width="100%">
                        <Grid container justifyContent="flex-start" gap={3} sx={{mx: 2}}>
                            {!props.empty ? items.map((item, index) => renderLink(item, index, props.onItemClick)) : null}
                        </Grid>
                        {!props.empty ?
                            <C036SearchField dataCypress='naviSearchField' customInputProps={searchFieldStyle}/> : null}
                    </Box>
                </CCOContainer>
            </Container>
            <Box display={{xs: "flex", lg: "none"}} justifyContent="space-between" alignItems="center" paddingY={6}>
                <Grid container justifyContent="flex-start">
                    {!props.empty ? items.map((item, index) => renderLink(item, index, props.onItemClick)) : null}
                </Grid>
            </Box>
        </React.Fragment>
    );
};

export default React.memo(TopNavi);
